import React, { useState } from 'react';
import { Box, Button, FloatingHelper } from '@wix/design-system';
import type { ButtonSize } from '@wix/design-system';
import { useRateAndReviewSectionContext } from '../../../exported-components/rate-and-reviews-section/rate-and-reviews-section-context';
import { AppType } from '../../../exported-components/rate-and-reviews-section/types';
import { useEssentials } from '../../../contexts/essentials-context';

interface WriteReviewButtonProps {
  size?: ButtonSize;
}
export function WriteReviewButton({ size = 'medium' }: WriteReviewButtonProps) {
  const {
    app,
    isEligibleForReview,
    setReviewModalOpen,
    onUserAction,
    onContactSupport,
  } = useRateAndReviewSectionContext();
  const { t } = useEssentials();

  const [isHelperOpen, setOpenHelper] = useState(false);

  function onButtonClick() {
    onUserAction(app.id, isEligibleForReview);
    if (isEligibleForReview) {
      setReviewModalOpen(true);
    } else {
      setOpenHelper(!isHelperOpen);
    }
  }

  return (
    <Box>
      <FloatingHelper
        dataHook="write-review-floating-helper"
        onClose={() => setOpenHelper(false)}
        appearance="light"
        opened={isHelperOpen}
        target={
          <Button
            size={size}
            dataHook="write-review-button"
            style={{ verticalAlign: 'middle' }}
            onClick={onButtonClick}
          >
            {t('solution.page.reviews.shareYourFeedBack')}
          </Button>
        }
        content={
          <FloatingHelper.Content
            title={t('solution.page.reviews.block-helper-title')}
            body={
              app.type === AppType.TPA
                ? t('solution.page.reviews.block-helper-description')
                : t('solution.page.reviews.block-helper-description-wix')
            }
            actionText={
              app.type === AppType.TPA
                ? t('solution.page.reviews.block-helper-cta1')
                : t('solution.page.reviews.block-helper-cta2')
            }
            actionTheme="standard"
            onActionClick={() => onContactSupport('review_section')}
          />
        }
        placement="top-end"
        zIndex={1456}
      />
    </Box>
  );
}
